import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import BlogNewsletter from "../BlogNewsletter";
import AuthorCard from "./AuthorCard";
import RelatedPosts from "./RelatedPosts";
import CTASection from "./CTA";

interface RelatedPost {
  title: string;
  slug: string;
  imageUrl?: string;
}

interface DataItem {
  subject: string;
  city: string;
  state: string;
}

interface BlogSidebarProps {
  authorName?: string;
  authorRole?: string;
  authorImage?: string;
  relatedPosts?: RelatedPost[];
  dataItem?: DataItem;
}

const BlogSidebar: React.FC<BlogSidebarProps> = ({
  authorName = "Lonny the Street Lawyer",
  authorRole = "Cannabis Activist and CEO",
  authorImage = "/images/lonny-the-street-lawyer/lonny-the-street-lawyer-profile-picture.jpg",
  relatedPosts = [],
  dataItem,
}) => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  // Simple animation for sidebar items on load
  useEffect(() => {
    if (!sidebarRef.current) return;

    const sidebarItems = sidebarRef.current.querySelectorAll(".sidebar-item");

    gsap.fromTo(
      sidebarItems,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.1,
        duration: 0.5,
        ease: "power2.out",
        delay: 0.3,
      }
    );
  }, []);

  return (
    <aside ref={sidebarRef} className="lg:col-span-4">
      {/* Author Card Component */}
      <AuthorCard
        authorName={authorName}
        authorRole={authorRole}
        authorImage={authorImage}
      />

      {/* Newsletter Subscription */}
      <div className="sidebar-item mb-5">
        <BlogNewsletter />
      </div>

      {/* Related Posts */}
      {relatedPosts && relatedPosts.length > 0 && (
        <RelatedPosts posts={relatedPosts} />
      )}

      {/* Call to Action Component */}
      <CTASection />
    </aside>
  );
};

export default BlogSidebar;
